import { BaseEntityModalPayload } from './base-entity-modal-payload';

export class UncontrolledEntityModalPayload extends BaseEntityModalPayload {}
